import { Link, Route, Routes, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import HomePage from "./pages/Home";
import DagPage from "./pages/Dag";
import AccountPage from "./pages/Account";
import RoundPage from "./pages/Round";
import TxPage from "./pages/Tx";
import SnapshotsPage from "./pages/Snapshots";
import SendPage from "./pages/Send";
import FleetPage from "./pages/Fleet";
import SearchBar from "./components/SearchBar";
import ThemeToggle from "./components/ThemeToggle";
import HealthBadge from "./components/HealthBadge";
import { StatsProvider } from "./observations";

export default function App() {
  const nav = useNavigate();
  const [theme, setTheme] = useState<"dark" | "light">(
    () =>
      (localStorage.getItem("theme") as "dark" | "light" | null) ?? "dark",
  );
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <StatsProvider>
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-mesh-panel bg-mesh-bg/80 backdrop-blur sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-4 py-3 flex flex-wrap items-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 font-bold text-mesh-accent hover:opacity-80"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
              <circle cx="6" cy="9" r="1.5" fill="currentColor" />
              <circle cx="18" cy="9" r="1.5" fill="currentColor" />
              <circle cx="12" cy="18" r="1.5" fill="currentColor" />
              <line x1="6" y1="9" x2="18" y2="9" stroke="currentColor" strokeWidth="1" />
              <line x1="6" y1="9" x2="12" y2="18" stroke="currentColor" strokeWidth="1" />
              <line x1="18" y1="9" x2="12" y2="18" stroke="currentColor" strokeWidth="1" />
            </svg>
            <span>Simbi Mesh Explorer</span>
          </Link>
          <nav className="flex gap-3 text-sm">
            <Link to="/" className="hover:text-mesh-accent">Home</Link>
            <Link to="/dag" className="hover:text-mesh-accent">DAG</Link>
            <Link to="/fleet" className="hover:text-mesh-accent">Fleet</Link>
            <Link to="/snapshots" className="hover:text-mesh-accent">
              Snapshots
            </Link>
            <Link
              to="/send"
              className="px-2 py-0.5 rounded bg-mesh-accent/20 border border-mesh-accent text-mesh-accent hover:bg-mesh-accent/40"
            >
              Send tx
            </Link>
          </nav>
          <div className="flex-1 min-w-40">
            <SearchBar
              onResult={(kind, id) => {
                if (kind === "tx") nav(`/tx/${id}`);
                else if (kind === "account") nav(`/account/${id}`);
                else if (kind === "round") nav(`/round/${id}`);
              }}
            />
          </div>
          <HealthBadge />
          <ThemeToggle
            theme={theme}
            onToggle={() => setTheme(theme === "dark" ? "light" : "dark")}
          />
        </div>
      </header>
      <main className="flex-1 max-w-7xl mx-auto w-full px-4 py-6">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dag" element={<DagPage />} />
          <Route path="/fleet" element={<FleetPage />} />
          <Route path="/snapshots" element={<SnapshotsPage />} />
          <Route path="/send" element={<SendPage />} />
          <Route path="/tx/:id" element={<TxPage />} />
          <Route path="/account/:id" element={<AccountPage />} />
          <Route path="/round/:n" element={<RoundPage />} />
        </Routes>
      </main>
      <footer className="border-t border-mesh-panel text-mesh-mute text-xs text-center py-3">
        read-only mirror · spec v0.1 · all hashes BLAKE3, sigs ed25519
      </footer>
    </div>
    </StatsProvider>
  );
}
